import { Directive } from '@angular/core';
import { provideJsonEditor } from '@examdojo/core/json-editor';
import echartsOptionSchema from '@settings/echarts_block_schema.json';

@Directive({
  selector: '[dojoEchartsJsonEditor]',
  providers: [provideJsonEditor(echartsOptionSchema, 'echarts')],
  standalone: true,
})
export class EchartsJsonEditorDirective {}
